import { useSelector } from '../../../react-redux';

const useQueueData = () => {
  const queue = useSelector(state => state.getIn(['visitor', 'queueList']));
  const queueInline = useSelector(state => state.getIn(['visitor', 'queueInline']));

  return {
    queue,
    queueInline
  };
};

export default useQueueData;
